<template>
  <div
    id="editor-cta"
    :style="{ top: top + 20 + 'px', left: left + 'px' }"
    :class="{
      'translate-left': translateLeft && !translateTopLeft,
      'translate-right': translateRight && !translateTopRight,
      'translate-top': translateTop,
      'translate-top-left': translateTopLeft,
      'translate-top-right': translateTopRight
    }"
  >
    <div class="content">
      <div class="header">
        <h4>{{ cta.heading }}</h4>
        <span class="text-small text-muted" @click="$emit('close')"> <i class="fa-light fa-times"></i></span>
      </div>
      <div class="description">
        <p>
          {{ cta.text }}
        </p>
      </div>
      <div class="actions">
        <button class="btn btn-primary btn-inverted btn-xs" @click="$emit('show-signup-form'), $emit('close')">
          {{$t("demo.cta.signup")}}
        </button>
        <button class="btn btn-primary btn-invert btn-xs" @click="$emit('show-hubspot-form'), $emit('close')">
          {{$t("demo.cta.book-demo")}}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import EventBus from "@/assets/js/eventBus.js";
export default {
  props: {
    showContent: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      ctaMessages: {
        createNew: {
          heading: this.$t("demo.cta.messages.create-new.heading"),
          text: this.$t("demo.cta.messages.create-new.text")
        },
        dragNdrop: {
          heading: this.$t("demo.cta.messages.drag-and-drop.heading"),
          text: this.$t("demo.cta.messages.drag-and-drop.text")
        },
        extraVars: {
          heading: this.$t("demo.cta.messages.extra-variables.heading"),
          text: this.$t("demo.cta.messages.extra-variables.text")
        },
        globalSyns: {
          heading: this.$t("demo.cta.messages.global-synonyms.heading"),
          text: this.$t("demo.cta.messages.global-synonyms.text")
        },
        convertScenario: {
          heading: this.$t("demo.cta.messages.convert-scenario.heading"),
          text: this.$t("demo.cta.messages.convert-scenario.text")
        },
        convertVariant: {
          heading: this.$t("demo.cta.messages.convert-variant.heading"),
          text: this.$t("demo.cta.messages.convert-variant.text")
        },
        default: {
          heading: this.$t("demo.cta.messages.default.heading"),
          text: this.$t("demo.cta.messages.default.text")
        }
      },
      hideContent: true,
      windowHeight: null,
      windowWidth: null
    };
  },

  computed: {
    ctaContent() {
      return this.$store.state.editorCtaContent;
    },
    top() {
      return this.ctaContent.y;
    },
    left() {
      return this.ctaContent.x;
    },
    cta() {
      return this.ctaMessages[this.ctaContent.action] || this.ctaMessages.default;
    },
    topPercentage() {
      return Math.floor((this.top / this.windowHeight) * 100);
    },
    leftPercentage() {
      return Math.floor((this.left / this.windowWidth) * 100);
    },
    translateTop() {
      return this.topPercentage > 75 && !this.translateLeft && !this.translateRight;
    },
    translateLeft() {
      return this.leftPercentage > 80;
    },
    translateRight() {
      return this.leftPercentage < 12;
    },
    translateTopLeft() {
      return this.translateLeft && this.topPercentage > 75;
    },
    translateTopRight() {
      return this.translateRight && this.topPercentage > 75;
    }
  },
  methods: {
    onOutsideClick(event) {
      if (!this.$el.contains(event.target)) {
        this.$emit("close");
      }
    },
    setWindowSize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
    }
  },
  mounted() {
    this.setWindowSize();
    EventBus.$once("closeCta", () => {
      this.$emit("close");
    });
    setTimeout(() => {
      if (!this.$root.outsideClickHandler) {
        this.$root.outsideClickHandler = (event) => this.$root.$emit("window-click", event);
        window.addEventListener("click", this.$root.outsideClickHandler);
      }
      this.$root.$on("window-click", this.onOutsideClick);
    }, 10);

    if (this.$store.state.userDevice !== "desktop") {
      document.addEventListener("focusout", this.setWindowSize(), true); // Might fix the soft keyboard misplacement on ipad...
      document.addEventListener("focusin", this.setWindowSize(), true);
    }
  },
  beforeDestroy() {
    if (this.$store.state.userDevice !== "desktop") {
      document.removeEventListener("focusout", this.setWindowSize(), true);
      document.removeEventListener("focusin", this.setWindowSize(), true);
    }
    this.$root.$off("window-click", this.onOutsideClick);
  }
};
</script>

<style lang="less">
#editor-cta {
  top: 3%;
  left: 50%;
  position: absolute;
  z-index: 999;
  max-width: 230px;
  background: var(--background-white);
  padding: 12px;
  border-radius: var(--standard-border-radius);
  transform: translateX(-50%);
  filter: drop-shadow(-1px 0px 4px rgba(0, 0, 0, 0.2));

  &::before {
    content: "";
    top: 0px;
    left: 50%;
    width: 10px;
    height: 10px;
    background-color: var(--background-white);
    position: absolute;
    transform: rotate(45deg) translateX(-50%);
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  &.translate-left {
    transform: translateX(calc(-100% - 10px));
    &::before {
      left: calc(100% - 10px);
      top: 0px;
      transform: rotate(0deg);
    }
  }

  &.translate-right {
    transform: translateX(10px);
    &::before {
      left: 0px;
      top: 0px;
      transform: rotate(0deg);
    }
  }

  &.translate-top {
    transform: translateX(-50%) translateY(calc(-100% - 35px));
    &::before {
      top: calc(100% - 2px);
    }
  }

  &.translate-top-right {
    transform: translateX(10px) translateY(calc(-100% - 35px));
    &::before {
      left: 0px;
      top: calc(100% - 10px);
      transform: rotate(0deg);
    }
  }

  &.translate-top-left {
    transform: translateX(10px) translateY(calc(-100% - 35px));
    &::before {
      left: 0px;
      top: calc(100% - 10px);
      transform: rotate(0deg);
    }
  }

  .actions {
    display: flex;
    flex-direction: row;
    gap: 8px;

    button {
      white-space: nowrap;
    }
  }
}
</style>
